<template>
  <div class="HubUserSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubUserSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubUserSettings-main lxn-pos-rel">
      <div class="HubUserSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.HubUserSettings_title}}
          </template>
          <template v-slot:body>
            <div v-for="(user, index) in hubUsers" :key="index" class="HubUserSettings-wrapper-users lxn-w100 lxn-border-round lxn-overflow-hidden">
              <div class="HubUserSettings-user-icon lxn-h100" :class="$store.getters.language.floatClass">
                <ButtonIcon :size="40" bgColor="#ECECEC" icon="user" iconColor="#53636C" :padding="8" />
              </div>
              <div class="HubUserSettings-wrapper-user-text lxn-h100" :class="$store.getters.language.floatClass">
                <div class="HubUserSettings-user-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{hubUsers[index].name}}
                </div>
                <div class="HubUserSettings-user-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{hubUsers[index].mobile}}
                </div>
              </div>
              <div class="HubUserSettings-user-setting lxn-h100" :class="$store.getters.language.floatClass">
                <ButtonIcon @click="editUser(index)" :size="50" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
              </div>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="HubUserSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="addNewUser" bgColor="#1EA5DE" iconRight="addUser" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isHubOffline">
          {{$store.getters.language.texts.HubUserSettings_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'HubUserSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    ButtonIcon,
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
    }
  },
  mounted: function () {
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    this.$store.dispatch('getUserList', {messagingHook: messagingHook,hubUUID: this.hub.uuid})
    .then( response => {
      var userList = response.body.bodyContent.userList;
      for(var i = 0; i < userList.length; i++){
        if(this.$store.getters.getUserByUUID(this.hub.index, userList[i].uuid) == -1){
          this.$store.commit('addNewUserToHub', {hubIndex: this.hub.index, uuid: userList[i].uuid, name: 'User', isOwner: false, mobile: '-'});
        }
        //TODO: delete users that are not in hub anymore.
      }
    })
    .catch( response => {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    });
  },
  watch: {
  },
  computed: {
    hubUsers: function () {
      return this.hub.users;
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.hub.color];
    },
  },
  methods: {
    goBack: function () {
      this.$router.push('/hubSettings/' + this.hub.uuid);
    },
    editUser: function (userIndex) {
      this.$router.push('/editUser/' + this.hub.uuid + "/" + userIndex)
    },
    addNewUser: function () {
      this.$router.push('/selectAddNewUserType/' + this.hub.uuid);
    },
  }
}
</script>

<style>
  .HubUserSettings-topCurve-wrapper {
    height: 200px;
  }
  .HubUserSettings-main {
    z-index: 2;
  }
  .HubUserSettings-main-wrapper {
    min-height: 150px;
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .HubUserSettings-wrapper-users {
    height: 50px;
    background-color: #FFFFFF;
    margin-top: 14px;
  }
  .HubUserSettings-user-icon {
    width: 50px;
    padding: 5px;
  }
  .HubUserSettings-wrapper-user-text {
    width: calc(100% - 100px);
  }
  .HubUserSettings-user-text {
    height: 25px;
    line-height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    color: #52626C;
  }
  .HubUserSettings-user-setting {
    width: 50px;
  }
  .HubUserSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .HubUserSettings-wrapper-fieldTitle:first-child {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
  }
  .HubUserSettings-wrapper-fieldTitle {
    height: 35px;
    padding-top: 10px;
    line-height: 25px;
    color: #52626C;
  }
  .HubUserSettings-wrapper-searchIcon {
    width: 40px;
    height: 40px;
    left: 5px;
    top: 5px;
  }
  .HubUserSettings-wrapper-ssidDropDown  {
    height: 0px;
  }
</style>
